import { Action } from '@ngrx/store';

export function getValueSetListType<TModel>(module: string, type: { new(): TModel; }): string {
  return `[${module}] Get Selection ${(type as any).$typeName}`;
}

export class GetValueSetListAction<TModel> implements Action {
  readonly type: string;

  constructor(module: string, modelType: { new(): TModel; }, public payload: { key: string, searchTerm:string, hideEmpty:boolean }) {
    this.type = getValueSetListType(module, modelType);
  }
}






// WEBPACK FOOTER //
// ./src/app/vocabulary/store/actions/GetValueSetListAction.ts